<template>
    <div class="form-group" :class="{disabled: disabled}">
        <label :for="id" class="pppp-label">{{ getLabel }}</label>
        <HelpButton v-if="help" :id="helpId" />
        <textarea 
            v-model="value"
            :id="id" 
            :name="id" 
            class="form-control pppp-textarea" 
            :rows="rows" 
            :cols="cols" 
            :placeholder="placeholder" 
            :required="required"
            :disabled="disabled"></textarea>
        <div v-if="required" class="pppp-validation-msg">
            <span class="glyphicon glyphicon-exclamation-sign"></span> Tämä kenttä on pakollinen!
        </div>
    </div>
</template>

<script>
import HelpButton from './HelpButton.vue';

export default {
    name: 'FormTextArea',
    components: {
        HelpButton
    },
    props: {
        modelValue: String,
        id:  String,
        label: String,
        placeholder: String,
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        help: {
            type: Boolean,
            default: false
        },
        helpId: String,
        rows: {
            type: Number,
            default: 3
        },
        cols: {
            type: Number,
            default: 50
        }
    },
    emits: ['update:modelValue'],
    computed: {
        getLabel() {
            if (this.required) {
                return '* ' + this.label;
            }
            return this.label;
        },
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
}
</script>

<style scoped>

</style>
